module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABaUlEQVQ4T7WVy0rDQBSG/5OZ1DQRvIAXpNCdC0HEJxFxJUpXgq/R1yiIi9LiSsQnkSJ0YUEQSlEXXsCmscnkSCwT4yWllDHLmX+++c9lTgh5X73lIXLdYgEzTEIkMmKlBkO8Q/o+Klv9v47Sr8Vaz4UXLzpxZOdeBiCwZIi+9YTjNT+r+w5s3i04iufHgX7uBYJecFB+1utfwClgGpKFjoC1nusUhyvZ25mlrSy1T4wdBtY/cwjcMOFSxOKMKAqz+mBQeEjCHwEb3VI2ZxFjlYhOAGzkhN9m5iNJuE9dJjk9LHUJ9ZbnYG5ZbyTOYlIXY2Ba2rZY7GadBnh9JJx2lhxpz2pVRFQhRnWSwjChKpnrqcsofKNio1Pi2E5bRIHOAWxPAgRwJcB7aYWtMCSneVuGsqzUIeiaAG8SIAN9Cd5MtSKOzQONh2y8KObbxnhj/8vTS6BGh4NupCmg+eNLQ40O2OzzmPIX8AHqOerJY8FUtQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ellipse.png
// module id = fC/g
// module chunks = 1